import styled, { css } from 'styled-components';
import { breakpoint, fontSettings, hideScrollbar } from '@lerna-core';
import { FiltersResetStyledProps } from './filtersReset.model';

export const FiltersResetWrapper = styled.div`
  ${breakpoint(
    'mediumDown',
    css`
      margin: 0 -20px;
      padding: 0 20px;
      width: auto;
      overflow-x: auto;
      ${hideScrollbar()}
    `
  )}
`;

export const FiltersReset = styled.div<FiltersResetStyledProps>`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  gap: 8px;
  ${({ isMobileType, theme }): string =>
    !isMobileType
      ? 'margin-bottom: 32px;'
      : `padding: 16px 0; border-bottom: 1px solid ${theme.COLOR.BLACK_08};`};

  ${({ isMobileType, theme }): ReturnType<typeof css> | string =>
    breakpoint(
      'mediumDown',
      !isMobileType
        ? css`
            margin-bottom: 0;
            flex-wrap: nowrap;
            width: max-content;
          `
        : css``,
      theme.IS_MOBILE
    )}
`;

export const FiltersResetFound = styled.div`
  color: ${(props): string => props.theme.COLOR.TEXT_DARK_COLOR};
  ${({ theme }): string => fontSettings(theme.FONT.SIZE_15, theme.FONT)};
  font-weight: 500;
  margin-right: 8px;
`;
